import React, { useState, useEffect } from 'react';
import { ApSimpleDropdown } from '@alixpartners/ui-components';

import { QueryStringContext } from 'contexts/QueryStringContext';
import { SettingsOptionsContext } from 'contexts/SettingsOptionsContext';
import { convertToArray } from 'Details/utils';
import { azSorter } from 'Pmi/utils';
import { useDebouncedEffect } from 'utils/customHooks';

export const MAX_COMPANIES = 4;

export class CompaniesSelect extends React.Component {
	state = {
		options: this.getCompaniesOptions(this.props.data),
	};

	getCompaniesOptions(companiesList) {
		return companiesList.map(companyName => ({
			label: companyName,
			value: companyName,
		}));
	}

	componentDidMount() {
		const { companies, data: companiesList, onChange } = this.props;

		if (!companies || companies.length === 0) {
			onChange({
				companies: companiesList.slice(0, MAX_COMPANIES),
			});
		}
	}

	handleChange = state => {
		const companies = state.map(item => item.value).sort(azSorter);

		if (!companies.length || companies.length > MAX_COMPANIES) {
			return;
		}

		const { onChange } = this.props;

		onChange({ companies });
	};

	render() {
		const { companies } = this.props;
		const { options } = this.state;

		const companiesCount = Array.isArray(companies)
			? companies.length
			: companies
				? 1
				: 0;

		const selectedOptions = options.filter(
			option =>
				Array.isArray(companies)
					? companies.includes(option.value)
					: companies === option.value
		);

		return (
			<ApSimpleDropdown
				multiple
				options={options}
				selected={selectedOptions}
				label={`${companiesCount} compan${
					companiesCount === 1 ? 'y' : 'ies'
				} selected`}
				onChange={this.handleChange}
				maxItems={4}
				message="Select up to 4 companies max"
			/>
		);
	}
}

const CompaniesChangeWrapper = props => {
	const [selectedCompanies, setSelectedCompanies] = useState(
		props.companies || []
	);
	useEffect(
		() => {
			if ((selectedCompanies || []).join() !== (props.companies || []).join()) {
				setSelectedCompanies(props.companies);
			}
		},
		// eslint-disable-next-line react-hooks/exhaustive-deps
		[props.companies]
	);

	useDebouncedEffect(
		() => {
			if ((selectedCompanies || []).join() !== (props.companies || []).join()) {
				props.onChange({ companies: selectedCompanies });
			}
		},
		// eslint-disable-next-line react-hooks/exhaustive-deps
		[selectedCompanies],
		1000
	);

	return (
		<CompaniesSelect
			{...props}
			onChange={({ companies }) => setSelectedCompanies(companies)}
			companies={selectedCompanies}
		/>
	);
};

export default props => (
	<SettingsOptionsContext.Consumer>
		{({ options: _0 }) => (
			<QueryStringContext.Consumer>
				{({ companies, setQueryStringStateAndPush }) => (
					<CompaniesChangeWrapper
						{...props}
						/**TODO: pass here info about available companies number */
						companies={convertToArray(companies)}
						onChange={setQueryStringStateAndPush}
					/>
				)}
			</QueryStringContext.Consumer>
		)}
	</SettingsOptionsContext.Consumer>
);
